
/**
 * Identity if an object already wrapped by layer
 */

const generateUID = (() => {
    let count = 0;
    return () => ++count;
})()

import { SYM_LAYER_INDENTIFY, SYM_LAYER_UID } from "../../../enum/Symbol";

const storeIsLayer = new WeakSet();

window['storeIsLayer'] = storeIsLayer;

export const identityLayer = (o, naming) => {
    storeIsLayer.add(o);
    if (typeof o !== 'object' || Array.isArray(o)) return;
    if (SYM_LAYER_UID in o) return;
    Object.defineProperty(o, SYM_LAYER_UID, {
        value: generateUID(),
        writable: false,
        configurable: true
    })
}

export const isLayer = (o) => {
    // return o !== null && typeof o === 'object' && o.hasOwnProperty(SYM_LAYER_INDENTIFY);
    return storeIsLayer.has(o);
}

export const getLayerUID = (layer) => layer[SYM_LAYER_UID]

const output = {
    identityLayer, isLayer
}

const useLayerIdentity = () => output;

// export {
//     identityLayer,
//     isLayer
// }

export default useLayerIdentity;